<template lang="pug">
  v-expansion-panels.app-expansion-panels(
    v-bind="$attrs"
  )
    slot
</template>

<script>
// ВРЕМЕННОЕ РЕШЕНИЕ!
// В дальнейшем глобально стилизовать панели и избавиться от этих компонентов
export default {
};
</script>

<style lang="scss" scoped>
.app-expansion-panels {
  &:nth-child(n) {
    gap: 16px;
  }
}
</style>
